import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Alert, Button, Group, Modal, Select, Stack, Text, TextInput } from '@mantine/core'
import { newTaskFields } from '../lib/taskMove'

// Opens from the + of a board column. The new task takes the column's value; plan and bucket columns fix the board.
export default function QuickCreate({ column, groupBy, data, writeConnected, consent, create, onClose }) {
  const { t } = useTranslation()
  const fixedBoard = groupBy === 'plan' ? column.key : groupBy === 'bucket' ? column.key.split(':')[0] : null
  const boards = (data?.boards || []).filter(board => fixedBoard ? board.id === fixedBoard : !newTaskFields(groupBy, column.key, board).skip)
  const [boardId, setBoardId] = useState(boards[0]?.id || null)
  const board = boards.find(item => item.id === boardId)
  const fixedBucket = groupBy === 'bucket' ? column.key.split(':')[1] : null
  const [bucketId, setBucketId] = useState(fixedBucket || board?.buckets[0]?.id || null)
  const [title, setTitle] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  const chooseBoard = id => { setBoardId(id); setBucketId(boards.find(item => item.id === id)?.buckets[0]?.id || null) }
  async function submit(event) {
    event.preventDefault()
    const { planId, fields } = newTaskFields(groupBy, column.key, board)
    setBusy(true); setError('')
    try { await create({ planId, bucketId, title: title.trim(), ...fields }); onClose() }
    catch (e) { setError(e.message) }
    finally { setBusy(false) }
  }
  return <Modal opened onClose={() => { if (!busy) onClose() }} title={t('Nieuwe taak in {{value0}}', { value0: column.title })} size="md">
    {!writeConnected ? <Stack><Text size="sm">{t('Microsoft vraagt eenmalig toestemming om taken te maken en te bewerken.')}</Text>{consent}</Stack>
    : !boards.length ? <Text size="sm">{t('Geen van de bronborden in deze view heeft dit label.')}</Text>
    : <form onSubmit={submit}><Stack>
      {error && <Alert color="red" role="alert">{t(error)}</Alert>}
      <TextInput label={t('Titel')} value={title} onChange={event => setTitle(event.target.value)} maxLength={255} required data-autofocus/>
      {!fixedBoard && <Select label={t('Bronbord')} data={boards.map(item => ({ value: item.id, label: item.title }))} value={boardId} onChange={chooseBoard} allowDeselect={false}/>}
      {!fixedBucket && board && <Select label={t('Bronbucket')} data={board.buckets.map(bucket => ({ value: bucket.id, label: bucket.name }))} value={bucketId} onChange={setBucketId} allowDeselect={false}/>}
      <Text size="xs" c="dimmed">{t('De taak komt in Planner op het gekozen bord, met de waarde van deze kolom.')}</Text>
      <Group justify="flex-end"><Button variant="default" onClick={onClose} disabled={busy}>{t('Annuleren')}</Button><Button type="submit" loading={busy} disabled={!title.trim() || !bucketId}>{t('Taak maken')}</Button></Group>
    </Stack></form>}
  </Modal>
}
